import React from 'react'
import SvgIcon from '@mui/material/SvgIcon'

const icon = function (props) {
  return (
    <SvgIcon width="21" height="33" viewBox="0 0 21 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M9 25C7.343 25 6 23.657 6 22V18C6 16.343 7.343 15 9 15C9.603 14.994 15 14 15 10C15 8 13 6 10 6C7.559 6 6 8 6 9C6 10.657 4.657 12 3 12C1.343 12 0 10.657 0 9C0 4.122 4.58 0 10 0C18 0 21 5.982 21 11C21 15.145 18.723 18.313 14.587 19.92C13.687 20.271 12.797 20.507 12 20.667V22C12 23.657 10.657 25 9 25Z" fill="currentColor" />
      <path d="M9 33C10.6569 33 12 31.6569 12 30C12 28.3431 10.6569 27 9 27C7.34315 27 6 28.3431 6 30C6 31.6569 7.34315 33 9 33Z" fill="currentColor" />
    </SvgIcon>
  )
}

export default icon;
